export default {"src":"/_next/static/media/star-half-blue-redesign.89d5de8d.svg","height":12,"width":12};